import React from 'react';
import { CheckCircle2Icon, XCircleIcon } from 'lucide-react';
import { Section, SectionTitle } from '../Section';
import { CtaBlock } from '../CtaBlock';
import { beforeItems, afterItems } from '../../data/content';
export function BeforeAfter() {
  return <Section tone="panel" data-id="element-73" data-mp="26k9z6npv1lel">
      <SectionTitle data-id="element-74" data-mp="22l151hqwrlii">
        Stop second-guessing yourself every time you turn on your welder
      </SectionTitle>

      <div className="mt-8 grid gap-4 lg:grid-cols-2 lg:gap-6" data-id="element-75" data-mp="2zba20vcggj4o">
        <div className="rounded-2xl border border-red-500/25 bg-red-500/[0.05] p-5" data-id="element-76" data-mp="2z8nswr9x1vkc">
          <h3 className="font-display text-xl font-bold uppercase tracking-wide text-red-400 sm:text-2xl" data-id="element-77" data-mp="2u9ufszyjk6kp">
            Before…
          </h3>
          <ul className="mt-4 space-y-3" data-id="element-78" data-mp="2lbsc2cnfaztq">
            {beforeItems.map(item => <li key={item} className="flex gap-3" data-id="element-79" data-mp="1eux2ldpghrt3">
                <XCircleIcon className="mt-0.5 h-5 w-5 shrink-0 text-red-400/80" aria-hidden="true" data-id="element-80" data-mp="1ewhvkyw4h2ou" />
                <span className="text-[15px] leading-snug text-white/70" data-id="element-81" data-mp="174ukmqvi573r">
                  {item}
                </span>
              </li>)}
          </ul>
        </div>

        <div className="rounded-2xl border border-teal/40 bg-teal/[0.07] p-5" data-id="element-82" data-mp="y4o5z1o2i130">
          <h3 className="font-display text-xl font-bold uppercase tracking-wide text-teal-bright sm:text-2xl" data-id="element-83" data-mp="y6se5vt01m93">
            With Master Welding System…
          </h3>
          <ul className="mt-4 space-y-3" data-id="element-84" data-mp="oe33h359wcet">
            {afterItems.map(item => <li key={item} className="flex gap-3" data-id="element-85" data-mp="t6mq0plxuhvr">
                <CheckCircle2Icon className="mt-0.5 h-5 w-5 shrink-0 text-teal-bright" aria-hidden="true" data-id="element-86" data-mp="t7frpc61ih71" />
                <span className="text-[15px] leading-snug text-white/85" data-id="element-87" data-mp="jgkytoyagjcm">
                  {item}
                </span>
              </li>)}
          </ul>
        </div>
      </div>

      <CtaBlock className="mt-10" headline="Stop guessing. Start welding with a system." data-id="element-88" data-mp="ads9vsckwjpy" />
    </Section>;
}